import { FormHints } from '../FormHints/FormHints.component';
import React, { ComponentPropsWithRef, FC, forwardRef } from 'react';
import { CheckIcon } from '@components/icons/Check.icon';
import { CheckboxProps } from '@form/business/form.types';
import classnames from 'classnames';

const Checkbox: FC<CheckboxProps & ComponentPropsWithRef<'label'>> = forwardRef(
  (
    {
      disabled,
      label,
      checked,
      onCheck,
      variant = 'checkbox',
      className,
      validators,
      isDarkGreen = false,
      isHintVisible,
      multilineLabel,
      ...rest
    },
    checkboxRef
  ) => {
    const rootClassName = classnames(
      variant,
      { disabled },
      isHintVisible && validators && validators.some((v) => !v.isValid) && 'error',
      multilineLabel ? 'multiline-label' : '',
      isDarkGreen ? 'dark-green-style' : '',
      className
    );
    return (
      <label ref={checkboxRef} className={rootClassName} {...rest}>
        <div className="input-wrapper">
          <input checked={checked} disabled={disabled} onChange={() => onCheck(!checked)} type={variant} />
          <div className={`checkbox-bg ${checked ? 'checked' : 'unchecked'}`}>
            {variant === 'checkbox' && <CheckIcon className="check" height={20} width={20} />}
          </div>
          <div className="checkbox-label">{label}</div>
        </div>
        <FormHints isHintVisible={isHintVisible && !disabled} validators={validators} />
      </label>
    );
  }
);

export { Checkbox };
